import { HStack, Link } from '@direct-frontend/components';
import { type TestProps } from '@direct-frontend/components/testing';
import { ResponsiveImage } from '../../../ResponsiveImage';
import { type OrderProductProps } from '../../lib/types';
import styles from './OrderProductImage.module.css';

interface OrderProductImageProps
    extends Pick<OrderProductProps, 'url' | 'isExpressCheckout' | 'image' | 'name'>,
        TestProps {}

export const OrderProductImage = (props: OrderProductImageProps) => {
    const { 'data-testid': dataTestId = 'OrderProductImage', url, image, name, isExpressCheckout } = props;

    return (
        <HStack
            {...(url && isExpressCheckout ? { as: Link, href: url, target: '_blank' } : {})}
            className={styles.imageContainer}
            data-testid={dataTestId}
        >
            <ResponsiveImage width="100%" height="100%" src={image} borderRadius="8" alt={name} />
        </HStack>
    );
};
